import React, { useEffect, useState } from 'react'
import { Box, Stack, Typography, Input, Chip, Accordion, AccordionSummary, AccordionDetails} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Droppable } from 'react-beautiful-dnd';

import StudentInfoCard from '../StudentInfoCard/StudentInfoCard';

function Group(props) {
    
    const [ expand, setExpand ] = useState(props.expandAll);
    
    const handleIndividualExpand = (event) => {
        setExpand(!expand)
      }
        
      useEffect(() => {
        setExpand(props.expandAll)
      }, [props.expandAll])
      
  return (
    <Droppable key={props.project.project_id} droppableId={props.project.project_id.toString()}>
    {(provided) => (
    <div ref={provided.innerRef} {...provided.droppableProps} style={props.project.project_id === 0 ? {marginBottom: '33%'} : {marginBlock: 10}}>

    <Accordion 
        key={props.project.project_id} 
        defaultExpanded 
        defaultValue={expand}
        sx={props.project.project_id === 0 ? 
          { boxShadow: 4 , backgroundColor: '#474747', position: 'fixed', zIndex: 1} 
          : 
          { boxShadow: 4}} 
        expanded={expand} 
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon/>}
        aria-controls="panel1a-content"
        onClick={handleIndividualExpand}
      >
        <Typography 
          style={props.project.project_id === 0 ? { width:'50%', color: 'white'} : { width:'50%'}} 
          variant="h5"
        >
            {props.project.name}
        </Typography>
        <div>
          {props.project.project_id !== 0 ? 
            <Stack direction="row" spacing={4} alignItems="center">

            <Typography style={{ width:'40%' }}>
            {"#1 votes: " + 
            (props.projectRankings
            && props.projectRankings.has(props.project.project_id) && props.projectRankings.get(props.project.project_id)[1]
            ? props.projectRankings.get(props.project.project_id)[1].length
            : 0)}
              </Typography>
              <div style={{display: "flex", width: "30%"}}>
                <Typography>Size: </Typography>
                <Input
                  type='number'
                  size="small"
                  inputProps={{min: 0, style:{padding: 0, marginInlineStart: "4px", width: "38px"}}}
                  defaultValue={props.project.capacity}
                  onClick={(event)=> event.stopPropagation()}
                  onBlur={(data) => {
                    
                    if (data.target.value) {
                      if (data.target.value < 0)
                        data.target.value = 0
                        props.project.capacity = parseInt(data.target.value);
                    }
                    else
                      props.project.capacity = 0;
                    props.handleCapacity(props.project);
                  }}
                />
              </div>
            <Chip label={props.project.end_semester} size='small'/>
            </Stack>
            : null
            }
          </div>
      </AccordionSummary>
      <AccordionDetails sx={props.project.project_id === 0 ? {overflow: 'auto', height: '30vh'} : {}} >
       {/* <Divider style={{marginBlockStart:"5px", }}/> */}
          {props.project.users.map((student, i) =>(
            <StudentInfoCard
              index={i}
              student={student}
              project_id={props.project.project_id}
              projectRanking={
              (props.studentRankings
              && props.studentRankings.has(student.user_id) 
              && (props.studentRankings.get(student.user_id).get(props.project.project_id))) 
              || "Unranked"}
              handleOpen={() => props.studentInfoTab(student)}
              key={student.user_id}
              locked={props.handleLockList}
              lockedList={props.lockedList}
            />
          ))}
          {/* makes a place for the new droppable to be dropped */}
          {provided.placeholder}

      </AccordionDetails>
    </Accordion>
    </div>
  )}
  </Droppable>

  )
}

export default Group
